import { BaseModel } from 'paliari-js-utils'
import { required, minLength } from 'vuelidate/lib/validators'

const attributes = {
  id: null,
  descricao: '',
  numero: '',
  ano: null,
  publicado_em: '',
  usuario: obj => ({ ...obj }),
  docs: obj => (obj ? [...obj] : []),
}

class DocPublicacao extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }

  static get validations() {
    return {
      descricao: { required, minLength: minLength(10) },
      numero: {},
      ano: {},
      publicado_em: {},
    }
  }

  get postParams() {
    const { numero, ano, descricao, publicado_em } = this

    return { numero, ano, descricao, publicado_em }
  }
}

export default DocPublicacao
